module.exports = __webpack_public_path__ + "static/media/Medcare Speciality Centre.77cc41e5.jpg";